import {
  IDocument,
  OriginEnum,
} from "app/bundles/requests/shared/models/document";
import { IGeojsonRequest } from "app/bundles/requests/shared/models/geojsonRequest";
import {
  IRawServiceRequestSummary,
  IWorkorderRequestSummary,
  IWorkorderRequestDetail,
  RequestSourceTypeEnum,
  workorderTypeEnum,
  IWorkorderRequestShallowDetail,
  IRawServiceRequestDetail,
} from "app/bundles/requests/shared/models/request";

export const mockedWorkordersGetAll: IGeojsonRequest = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5541, 45.4959] },
      properties: {
        id: 1,
        serviceRequestId: 91,
        type: workorderTypeEnum.external,
        requestNumber: "XX-1",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "ARB-TBE", name: "Arbre tombé" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.496] },
      properties: {
        id: 2,
        serviceRequestId: 92,
        type: workorderTypeEnum.external,
        requestNumber: "XX-2",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "ARB-TBE", name: "Arbre tombé" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5541, 45.4961] },
      properties: {
        id: 3,
        serviceRequestId: 93,
        type: workorderTypeEnum.external,
        requestNumber: "XX-3",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "ARC-BRC", name: "Branche tombée" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4962] },
      properties: {
        id: 4,
        serviceRequestId: 94,
        type: workorderTypeEnum.external,
        requestNumber: "XX-4",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "ARC-BRC", name: "Branche tombée" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5541, 45.4963] },
      properties: {
        id: 5,
        serviceRequestId: 95,
        type: workorderTypeEnum.external,
        requestNumber: "XX-5",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "BAL-MEC", name: "Balai mécanique" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4964] },
      properties: {
        id: 6,
        serviceRequestId: 96,
        type: workorderTypeEnum.external,
        requestNumber: "XX-6",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "BAL-MEC", name: "Balai mécanique" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5541, 45.4965] },
      properties: {
        id: 7,
        serviceRequestId: 97,
        type: workorderTypeEnum.external,
        requestNumber: "XX-7",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "CHA-GLI", name: "Chaussée glissante" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4966] },
      properties: {
        id: 8,
        serviceRequestId: 98,
        type: workorderTypeEnum.external,
        requestNumber: "XX-8",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "CHA-GLI", name: "Chaussée glissante" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5541, 45.4967] },
      properties: {
        id: 9,
        type: workorderTypeEnum.internal,
        requestNumber: "XX-9",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "CHA-PRC", name: "Chalet de parc" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 10,
        serviceRequestId: 910,
        type: workorderTypeEnum.external,
        requestNumber: "XX-10",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "CHA-PRC", name: "Chalet de parc" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 11,
        serviceRequestId: 911,
        type: workorderTypeEnum.external,
        requestNumber: "XX-11",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "PUI-1RE", name: "Puisard - Première intervention" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2018-12-10T14:40:30.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 12,
        serviceRequestId: 912,
        type: workorderTypeEnum.external,
        requestNumber: "XX-12",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "FEU-CEN", name: "Feux de circulation - Entretien" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2018-12-10T14:40:30.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 13,
        serviceRequestId: 913,
        type: workorderTypeEnum.external,
        requestNumber: "XX-13",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: {
          code: "FEU-CNV",
          name: "Feux de circulation - Nouvelle installation",
        },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2018-12-10T14:40:30.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 14,
        serviceRequestId: 914,
        type: workorderTypeEnum.external,
        requestNumber: "XX-14",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "ANI-MOR", name: "Animal mort" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2018-12-10T14:40:30.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 15,
        serviceRequestId: 915,
        type: workorderTypeEnum.external,
        requestNumber: "XX-15",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "TER-INS", name: "Terrain insalubre - Domaine privé" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2018-12-10T14:40:30.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 16,
        serviceRequestId: 916,
        type: workorderTypeEnum.external,
        requestNumber: "XX-16",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "DEP-NEI", name: "Dépôt illégal - Neige" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2018-12-10T14:40:30.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 17,
        serviceRequestId: 917,
        type: workorderTypeEnum.external,
        requestNumber: "XX-17",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "DEP-DEC", name: "Dépôt illégal - Déchets" },
        status: {
          code: "E",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2018-12-10T14:40:30.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 18,
        serviceRequestId: 918,
        type: workorderTypeEnum.external,
        requestNumber: "XX-18",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "PUI-1RE", name: "Puisard - Première intervention" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 19,
        serviceRequestId: 919,
        type: workorderTypeEnum.external,
        requestNumber: "XX-19",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "FEU-CEN", name: "Feux de circulation - Entretien" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 20,
        serviceRequestId: 920,
        type: workorderTypeEnum.external,
        requestNumber: "XX-20",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: {
          code: "FEU-CNV",
          name: "Feux de circulation - Nouvelle installation",
        },
        status: {
          code: "A",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 21,
        serviceRequestId: 921,
        type: workorderTypeEnum.external,
        requestNumber: "XX-21",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "ANI-MOR", name: "Animal mort" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 22,
        serviceRequestId: 922,
        type: workorderTypeEnum.external,
        requestNumber: "XX-22",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "TER-INS", name: "Terrain insalubre - Domaine privé" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 23,
        serviceRequestId: 923,
        type: workorderTypeEnum.external,
        requestNumber: "XX-23",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "DEP-NEI", name: "Dépôt illégal - Neige" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
    {
      type: "Feature",
      geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
      properties: {
        id: 24,
        serviceRequestId: 924,
        type: workorderTypeEnum.external,
        requestNumber: "XX-24",
        isReactivated: false,
        isRelaunched: false,
        description: "UIR -",
        responsible: {
          groupName: "TP VOIRIE VM",
          groupId: 32,
          userName: "Jean",
          userCode: "XMOBIL",
        },
        borough: {
          code: 12,
          name: "Anjou",
        },
        hasExistingTask: false,
        service: { code: "DEP-DEC", name: "Dépôt illégal - Déchets" },
        status: {
          code: "A",
          name: "Statut pour les icônes '*_stat.svg'",
          statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
        },
        estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
        formattedAddress: "801, rue Brennan, Montréal",
        creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
      },
    },
  ],
};

export const mockedWorkordersGetById: IWorkorderRequestShallowDetail[] = [
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 1,
    serviceRequestId: 91,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-1",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "ARB-TBE", name: "Arbre tombé" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5541, 45.4959] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 2,
    serviceRequestId: 92,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-2",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: true,
    service: { code: "ARB-TBE", name: "Arbre tombé" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.496] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 3,
    serviceRequestId: 93,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-3",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "ARC-BRC", name: "Branche tombée" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5541, 45.4961] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 4,
    serviceRequestId: 94,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-4",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "ARC-BRC", name: "Branche tombée" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4962] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 5,
    serviceRequestId: 95,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-5",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "BAL-MEC", name: "Balai mécanique" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5541, 45.4963] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 6,
    serviceRequestId: 96,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-6",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "BAL-MEC", name: "Balai mécanique" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4964] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 7,
    serviceRequestId: 97,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-7",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "CHA-GLI", name: "Chaussée glissante" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5541, 45.4965] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 8,
    serviceRequestId: 98,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-8",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "CHA-GLI", name: "Chaussée glissante" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4966] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 9,
    type: workorderTypeEnum.internal,
    hasServiceRequestLinkedTo: false,
    requestNumber: "XX-9",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "CHA-PRC", name: "Chalet de parc" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5541, 45.4967] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 10,
    serviceRequestId: 910,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-10",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "CHA-PRC", name: "Chalet de parc" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 11,
    serviceRequestId: 911,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-11",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "PUI-1RE", name: "Puisard - Première intervention" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 12,
    serviceRequestId: 912,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-12",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "FEU-CEN", name: "Feux de circulation - Entretien" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 13,
    serviceRequestId: 913,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-13",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: {
      code: "FEU-CNV",
      name: "Feux de circulation - Nouvelle installation",
    },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 14,
    serviceRequestId: 914,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-14",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "ANI-MOR", name: "Animal mort" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 15,
    serviceRequestId: 915,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-15",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "TER-INS", name: "Terrain insalubre - Domaine privé" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 16,
    serviceRequestId: 916,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-16",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "DEP-NEI", name: "Dépôt illégal - Neige" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 17,
    serviceRequestId: 917,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-17",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "DEP-DEC", name: "Dépôt illégal - Déchets" },
    status: {
      code: "E",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 18,
    serviceRequestId: 918,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-18",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "PUI-1RE", name: "Puisard - Première intervention" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 19,
    serviceRequestId: 919,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-19",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "FEU-CEN", name: "Feux de circulation - Entretien" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 20,
    serviceRequestId: 920,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-20",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: {
      code: "FEU-CNV",
      name: "Feux de circulation - Nouvelle installation",
    },
    status: {
      code: "A",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 21,
    serviceRequestId: 921,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-21",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "ANI-MOR", name: "Animal mort" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 22,
    serviceRequestId: 922,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-22",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "TER-INS", name: "Terrain insalubre - Domaine privé" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 23,
    serviceRequestId: 923,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-23",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "DEP-NEI", name: "Dépôt illégal - Neige" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
  {
    source: RequestSourceTypeEnum.workorderRequest,
    id: 24,
    serviceRequestId: 924,
    type: workorderTypeEnum.external,
    hasServiceRequestLinkedTo: true,
    requestNumber: "XX-24",
    isReactivated: false,
    isRelaunched: false,
    description: "UIR -",
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: "CGSNCM1",
      userName: "Jean",
    },
    hasExistingTask: false,
    service: { code: "DEP-DEC", name: "Dépôt illégal - Déchets" },
    status: {
      code: "A",
      name: "Statut pour les icônes '*_stat.svg'",
      statusDatetime: new Date("2017-08-14T04:00:00.000Z"),
    },
    estimatedCompletionDate: new Date("2040-02-01T05:00:00.000Z"),
    formattedAddress: "801, rue Brennan, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    geometry: { type: "Point", coordinates: [-73.5539, 45.4968] },
    creationDatetime: new Date("2018-12-10T14:40:30.000Z"),
    workorderRequestCreationDatetime: new Date("2018-12-30T14:40:30.000Z"),
    clients: [
      {
        name: "",
        telephones: [],
        address: "    ",
        comment: "",
        email: "",
        creationDatetime: new Date("2018-12-10T14:40:31.000Z"),
      },
    ],
  },
];

export const mockedWorkordersForeman: IDocument[] = [
  {
    creationDatetime: new Date("2021-08-05T21:14:21.000Z"),
    description: "Image fournie par le contremaître",
    id: "10980",
    workorderId: "1",
    origin: OriginEnum.foreman,
    type: null,
    url: "../../../../../../../../assets/images/logo.png",
    user: "CGSNCM1",
    filename: "mock",
  },
];

export const mockedServiceRequestGetAll = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.552272, 45.507912],
      },
      properties: {
        serviceRequestId: 3277428,
        requestNumber: "21-96",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-04-09T17:22:02.000Z",
        },
        requestedDatetime: "2021-10-09T17:22:02.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "250, rue Saint-Paul Est, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y1G9",
        activity: {
          code: "COL-REC",
          name: "Collecte des matières recyclables",
        },
        subject: "Collecte des matières recyclables",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: null,
          userCode: null,
          groupName: "TP VOIRIE VM",
          groupId: 312,
        },
        updatedDatetime: "2021-10-09T17:22:02.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.552272, 45.507912],
      },
      properties: {
        serviceRequestId: 3277441,
        requestNumber: "21-109",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-04-15T18:59:30.000Z",
        },
        requestedDatetime: "2021-04-15T18:59:30.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "250, rue Saint-Paul Est, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y1G9",
        activity: {
          code: "COL-REC",
          name: "Collecte des matières recyclables",
        },
        subject: "Collecte des matières recyclables",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "TP VOIRIE VM",
          groupId: 312,
        },
        updatedDatetime: "2021-04-15T18:59:30.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.553741, 45.508311],
      },
      properties: {
        serviceRequestId: 3279349,
        requestNumber: "21-2017",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-05-20T18:20:09.000Z",
        },
        requestedDatetime: "2021-05-20T18:20:09.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "462, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B3",
        activity: {
          code: "PAN-PRC",
          name: "Panier de parc à vider",
        },
        subject: "Panier de parc à vider",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "TP VOIRIE VM",
          groupId: 312,
        },
        updatedDatetime: "2021-05-20T18:20:09.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.55288, 45.508021],
      },
      properties: {
        serviceRequestId: 3277415,
        requestNumber: "21-83",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-03-30T18:14:01.000Z",
        },
        requestedDatetime: "2021-03-30T18:14:01.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "431, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B1",
        activity: {
          code: "COL-VRT",
          name: "Collecte de résidus verts",
        },
        subject: "Collecte de résidus verts",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "TP VOIRIE VM",
          groupId: 312,
        },
        updatedDatetime: "2021-03-30T18:14:01.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.55288, 45.508021],
      },
      properties: {
        serviceRequestId: 3277420,
        requestNumber: "21-88",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-03-30T19:26:39.000Z",
        },
        requestedDatetime: "2021-03-30T19:26:39.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "431, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B1",
        activity: {
          code: "COL-ENR",
          name: "Encombrants non ramassés",
        },
        subject: "Encombrants non ramassés",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "TP VOIRIE VM",
          groupId: 312,
        },
        updatedDatetime: "2021-03-30T19:26:39.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.55305899999999, 45.508112999999994],
      },
      properties: {
        serviceRequestId: 3279347,
        requestNumber: "21-2015",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-05-20T14:59:02.000Z",
        },
        requestedDatetime: "2021-05-20T14:59:02.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "431, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B1",
        activity: {
          code: "PUI-1RE",
          name: "Puisard - Première intervention",
        },
        subject: "Puisard - Première intervention",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "TP VOIRIE AGENTS TECHNIQUES",
          groupId: 313,
        },
        updatedDatetime: "2021-05-20T14:59:02.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.555401, 45.508129],
      },
      properties: {
        serviceRequestId: 3277410,
        requestNumber: "21-78",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-03-25T13:43:06.000Z",
        },
        requestedDatetime: "2021-09-24T13:43:05.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "155, rue Notre-Dame Est, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y1B5",
        activity: {
          code: "PUI-1RE",
          name: "Puisard - Première intervention",
        },
        subject: "Puisard - Première intervention",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "TP VOIRIE AGENTS TECHNIQUES",
          groupId: 313,
        },
        updatedDatetime: "2021-03-25T13:43:05.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.553553, 45.508233999999995],
      },
      properties: {
        serviceRequestId: 3277411,
        requestNumber: "21-79",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-03-27T11:41:06.000Z",
        },
        requestedDatetime: "2021-03-27T11:41:06.000Z",
        nbrDaysForResolution: 15,
        formattedAddress: "444, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B3",
        activity: {
          code: "PUI-1RE",
          name: "Puisard - Première intervention",
        },
        subject: "Puisard - Première intervention",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "TP VOIRIE AGENTS TECHNIQUES",
          groupId: 313,
        },
        updatedDatetime: "2021-03-27T11:41:06.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.55288, 45.508021],
      },
      properties: {
        serviceRequestId: 3277414,
        requestNumber: "21-82",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-03-30T18:13:57.000Z",
        },
        requestedDatetime: "2021-03-30T18:13:57.000Z",
        nbrDaysForResolution: 60,
        formattedAddress: "431, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B1",
        activity: {
          code: "COL-DEC",
          name: "Collecte de déchets",
        },
        subject: "Collecte de déchets",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "GROUPE TEST",
          groupId: 310,
        },
        updatedDatetime: "2021-03-30T18:13:57.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.55288, 45.508021],
      },
      properties: {
        serviceRequestId: 3277418,
        requestNumber: "21-86",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-03-30T18:50:24.000Z",
        },
        requestedDatetime: "2021-03-30T18:50:23.000Z",
        nbrDaysForResolution: 60,
        formattedAddress: "431, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B1",
        activity: {
          code: "COL-DEC",
          name: "Collecte de déchets",
        },
        subject: "Collecte de déchets",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "GROUPE TEST",
          groupId: 310,
        },
        updatedDatetime: "2021-03-30T18:50:23.000Z",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.55288, 45.508021],
      },
      properties: {
        serviceRequestId: 3277419,
        requestNumber: "21-87",
        status: {
          code: "TRANSMITTED",
          name: "Transmise",
          createdAt: "2021-03-30T18:58:57.000Z",
        },
        requestedDatetime: "2021-03-30T18:58:57.000Z",
        nbrDaysForResolution: 60,
        formattedAddress: "431, place Jacques-Cartier, Montréal",
        borough: "Ville-Marie",
        postalCode: "H2Y3B1",
        activity: {
          code: "COL-DEC",
          name: "Collecte de déchets",
        },
        subject: "Collecte de déchets",
        isReactivated: false,
        isRelaunched: false,
        responsible: {
          userName: "Jean",
          userCode: "xmobil",
          groupName: "GROUPE TEST",
          groupId: 310,
        },
        updatedDatetime: "2021-03-30T18:58:57.000Z",
      },
    },
  ],
};

export const mockedServiceRequestsGetById: IRawServiceRequestDetail[] = [
  {
    serviceRequestId: 3277428,
    requestNumber: "21-96",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-10-09T17:22:02.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-10-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "250, rue Saint-Paul Est, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y1G9",
    activity: {
      code: "COL-REC",
      name: "Collecte des matières recyclables",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Collecte des matières recyclables",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-10-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-10-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277441,
    requestNumber: "21-109",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-04-09T17:22:02.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "250, rue Saint-Paul Est, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y1G9",
    activity: {
      code: "COL-REC",
      name: "Collecte des matières recyclables",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Collecte des matières recyclables",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3279349,
    requestNumber: "21-2017",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-04-09T17:22:02.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "250, rue Saint-Paul Est, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y1G9",
    activity: {
      code: "PAN-PRC",
      name: "Panier de parc à vider",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Panier de parc à vider",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277415,
    requestNumber: "21-83",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-04-09T17:22:02.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "431, place Jacques-Cartier, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y3B1",
    activity: {
      code: "COL-VRT",
      name: "Collecte de résidus verts",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Collecte de résidus verts",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277420,
    requestNumber: "21-88",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-03-30T19:26:39.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    requestedDatetime: new Date("2021-03-30T19:26:39.000Z"),
    nbrDaysForResolution: 15,
    formattedAddress: "431, place Jacques-Cartier, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y3B1",
    activity: {
      code: "COL-ENR",
      name: "Encombrants non ramassés",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Encombrants non ramassés",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 24,
      groupName: "TP VOIRIE VM",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-03-30T19:26:39.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3279347,
    requestNumber: "21-2015",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-05-20T14:59:02.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "431, place Jacques-Cartier, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y3B1",
    activity: {
      code: "PUI-1RE",
      name: "Puisard - Première intervention",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Puisard - Première intervention",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 22,
      groupName: "TP VOIRIE AGENTS TECHNIQUES",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277410,
    requestNumber: "21-78",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-03-25T13:43:06.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "155, rue Notre-Dame Est, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y1B5",
    activity: {
      code: "PUI-1RE",
      name: "Puisard - Première intervention",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Puisard - Première intervention",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 22,
      groupName: "TP VOIRIE AGENTS TECHNIQUES",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277411,
    requestNumber: "21-79",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-03-27T11:41:06.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "444, place Jacques-Cartier, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y3B3",
    activity: {
      code: "PUI-1RE",
      name: "Puisard - Première intervention",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Puisard - Première intervention",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 22,
      groupName: "TP VOIRIE AGENTS TECHNIQUES",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277414,
    requestNumber: "21-82",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-03-30T18:13:57.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    nbrDaysForResolution: 15,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "431, place Jacques-Cartier, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y3B1",
    activity: {
      code: "COL-DEC",
      name: "Collecte de déchets",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Collecte de déchets",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 23,
      groupName: "GROUPE TEST",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277418,
    requestNumber: "21-86",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-03-30T18:50:24.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    nbrDaysForResolution: 60,
    formattedAddress: "431, place Jacques-Cartier, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y3B1",
    activity: {
      code: "COL-DEC",
      name: "Collecte de déchets",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Collecte de déchets",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 23,
      groupName: "GROUPE TEST",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-03-30T18:50:23.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
  {
    serviceRequestId: 3277419,
    requestNumber: "21-87",
    status: {
      code: "TRANSMITTED",
      name: "Transmise",
      createdAt: new Date("2021-03-30T18:58:57.000Z"),
    },
    comments: {
      code: null,
      "fr-CA": null,
      "en-CA": null,
    },
    requestedDatetime: new Date("2021-03-30T18:58:57.000Z"),
    nbrDaysForResolution: 60,
    media: [
      {
        origin: OriginEnum.foreman,
        url: "../../../../../../../../assets/images/logo.png",
      },
    ],
    formattedAddress: "431, place Jacques-Cartier, Montréal",
    borough: {
      name: "Ville-Marie",
      code: 12,
    },
    postalCode: "H2Y3B1",
    activity: {
      code: "COL-DEC",
      name: "Collecte de déchets",
    },
    location: {
      lat: 45.507912,
      long: -73.552272,
    },
    nbrOfCommunications: 1,
    subject: "Collecte de déchets",
    isReactivated: false,
    isRelaunched: false,
    responsible: {
      groupId: 23,
      groupName: "GROUPE TEST",
      userCode: null,
      userName: null,
    },
    updatedDatetime: new Date("2021-04-09T17:22:02.000Z"),
    clients: [
      {
        name: "nom",
        phones: [
          {
            type: null, // 'home' | 'work' | 'cell'
            number: "514-123-4567",
            extension: "1234",
          },
        ],
        address: "250 rue Saint-Paul Est Montréal Québec Canada",
        comment: "un texte libre",
        email: "njdkdjnjkd@hotmail.com",
        creationDatetime: new Date("2021-04-09T17:22:02.000Z"),
      },
    ],
    internalComments: [
      {
        internalComment: "commentaire interne",
        creationDatetime: new Date(),
        userCreatedBy: {
          userCode: "CGSNCM1",
          firstName: "Test",
          lastName: "GDT-Mobile",
        },
      },
    ],
  },
];
